const escapePrintViewText = (value) => {
    if (value === null || typeof value === 'undefined') {
        return ''
    }

    return String(value)
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#39;')
}

const replaceMediaLikeTagsWithIds = (html) => {
    if (!html) {
        return ''
    }

    const template = document.createElement('template')
    template.innerHTML = html

    template.content.querySelectorAll('*').forEach((element) => {
        const tagName = element.tagName.toLowerCase()
        const relatedMediaId = element.getAttribute('relatedmediaid')
            || element.getAttribute('related_media_id')

        if (!relatedMediaId) {
            return
        }

        const isImageLikeTag = tagName.includes('img') || element.hasAttribute('src')

        if (!isImageLikeTag) {
            return
        }

        element.replaceWith(`[image media id: ${escapePrintViewText(relatedMediaId)}]`)
    })

    return template.innerHTML
}

const normalizeInlineHtml = (html) => {
    if (!html) {
        return ''
    }

    const template = document.createElement('template')
    template.innerHTML = html

    const firstElement = template.content.firstElementChild
    const hasSingleParagraphNode = (
        firstElement &&
        template.content.childNodes.length === 1 &&
        template.content.firstChild === firstElement &&
        firstElement.tagName.toLowerCase() === 'p'
    )

    if (hasSingleParagraphNode) {
        return firstElement.innerHTML
    }

    return template.innerHTML
}

export {
    escapePrintViewText,
    normalizeInlineHtml,
    replaceMediaLikeTagsWithIds,
}
